import { buildContext } from './shared.js';
import { arc }        from './arc.js';
import { bar }        from './bar.js';
import { chart }      from './chart.js';
import { btn }        from './btn.js';
import { btnmatrix }  from './btnmatrix.js';
import { checkbox }   from './checkbox.js';
import { cpicker }    from './cpicker.js';
import { dropdown }   from './dropdown.js';
import { gauge }      from './gauge.js';
import { h3d }        from './h3d.js';
import { img }        from './img.js';
import { label }      from './label.js';
import { led }        from './led.js';
import { line }       from './line.js';
import { linemeter }  from './linemeter.js';
import { mtrx_btn }   from './mtrx_btn.js';
import { msgbox_btn } from './msgbox_btn.js';
import { msgbox }     from './msgbox.js';
import { obj }        from './obj.js';
import { page }       from './page.js';
import { qrcode }     from './qrcode.js';
import { roller }     from './roller.js';
import { slider }     from './slider.js';
import { spinner }    from './spinner.js';
import { switch_ }    from './switch.js';
import { tabview }    from './tabview.js';
import { tab }        from './tab.js';

export function buildMono(primary, secondary) {
    const ctx = buildContext(primary, secondary);
    return {
        arc:        arc(ctx),
        bar:        bar(ctx),
        chart:      chart(ctx),
        btn:        btn(ctx),
        btnmatrix:  btnmatrix(ctx),
        checkbox:   checkbox(ctx),
        cpicker:    cpicker(ctx),
        dropdown:   dropdown(ctx),
        gauge:      gauge(ctx),
        h3d:        h3d(ctx),
        img:        img(ctx),
        label:      label(ctx),
        led:        led(ctx),
        line:       line(ctx),
        linemeter:  linemeter(ctx),
        mtrx_btn:   mtrx_btn(ctx),
        msgbox_btn: msgbox_btn(ctx),
        msgbox:     msgbox(ctx),
        obj:        obj(ctx),
        page:       page(ctx),
        qrcode:     qrcode(ctx),
        roller:     roller(ctx),
        slider:     slider(ctx),
        spinner:    spinner(ctx),
        switch:     switch_(ctx),
        tabview:    tabview(ctx),
        tab:        tab(ctx),
    };
}
